import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  CardActionArea,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function Projects() {
  const navigate = useNavigate();

  const projects = [
    {
      id: "english-learning-chat",
      title: "English Learning Chat Agent",
      description:
        "An interactive AI chatbot system currently used by over 500 public schools, serving thousands of students daily. Features multi-agent architecture for realistic English conversation scenarios.",
      image: "/images/english_learning_chat/student_report.png",
      role: "AI Product Manager",
      impact:
        "Created the initial working demo and led AI design vision. Coordinated backend and engineering teams to bring the production system to life, now actively serving real students in daily English practice.",
    },
    {
      id: "liulishuo-ielts",
      title: "Liulishuo IELTS",
      description:
        "An AI-powered IELTS preparation platform that provides personalized learning experiences and real-time feedback for students preparing for the IELTS exam.",
      image: "images/ielts/ielts_cover.png",
      role: "Project Lead & AI Architect",
      impact:
        "Led a cross-functional team of 10+ to deliver adaptive learning, AI reports, and conversation assistants on a tight schedule. Successfully launched into production, now actively used by students across China.",
    },
    {
      id: "ai-teacher-toolbox",
      title: "AI Teacher Toolbox",
      description:
        "A comprehensive suite of AI-powered tools for educators to create, manage, and analyze educational content.",
      image: "/images/teacher_toolbox/tool_box.png",
      role: "AI Product Manager",
      impact:
        "Spearheaded the vision and implementation of a scalable system that empowers internal teams to rapidly prototype and release innovative AI tools for teachers.",
    },
    {
      id: "homework-digitization",
      title: "Homework Digitization Tool",
      description:
        "An innovative solution that converts teacher-created homework into structured digital formats using AI logic—no OCR required.",
      image: "images/homework/cover.png",
      role: "AI Product Manager & Backend Engineer",
      impact:
        "Designed the AI logic pipeline and built the backend system powering digitized homework at scale. The tool is now used in hundreds of schools and significantly improves grading efficiency.",
    },
    {
      id: "podcast-generator",
      title: "Podcast Generator",
      description:
        "An AI-powered internal tool that converts written content into polished podcast episodes at scale, designed for customer-facing use.",
      image: "images/podcast/title_output.png",
      role: "Creator & Full Stack Developer",
      impact:
        "Independently designed and implemented the full system—AI pipeline, backend, frontend, UI/UX, and deployment. Increased podcast generation capacity from a few per day to hundreds daily.",
    },
  ];

  const handleProjectClick = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Featured Projects
      </Typography>
      <Grid container spacing={4}>
        {projects.map((project) => (
          <Grid item xs={12} md={6} key={project.id}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
              <CardActionArea onClick={() => handleProjectClick(project.id)}>
                <CardMedia
                  component="img"
                  height="200"
                  image={project.image}
                  alt={project.title}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {project.title}
                  </Typography>
                  <Typography variant="subtitle1" color="primary" gutterBottom>
                    {project.role}
                  </Typography>
                  <Typography paragraph>{project.description}</Typography>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Impact:
                  </Typography>
                  <Typography variant="body2" paragraph>
                    {project.impact}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default Projects;
